import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AuthProvider from './components/AuthProvider';
import RoutesComponent from './RoutesComponents';

const Router: React.FunctionComponent = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RoutesComponent />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Router;
